// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// Selectors
import {
  userIdSelector,
  userAddressesSelector,
  gettingUserAddressesLoadingSelector,
  editingUserAddressesLoadingSelector,
  addingUserAddressesLoadingSelector,
  deletingUserAddressesLoadingByIdSelector,
} from '../selectors';
// Actions
import {
  getAddresses,
  newAddress,
  updateAddress,
  deleteAddress,
} from '../actions';
// Components
import MyAccountAddress from '../components/myAccount/MyAccountAddress';
// Styles
import './MyAccountAddressesPage.css';
// Types
import type { Address } from '../types';

type Props = {
  addresses: Address[],
  userId: ?number,
  getAddresses: () => void,
  onSubmitNewAddress: (address: Address) => void,
  onSubmitUpdateAddress: (address: Address) => void,
  onSubmitDeleteAddress: (addressId: number) => void,
  loading: boolean,
  editingLoading: boolean,
  addingLoading: boolean,
  deletingLoading: (id: number) => boolean,
};

const MyAccountAddressesPage = (props: Props) => {
  useEffect(() => {
    // get the user addresses
    if (props.userId) {
      props.getAddresses();
    }
  }, [props.userId]);

  return (
    <MyAccountAddress
      addresses={props.addresses}
      onSubmitNew={props.onSubmitNewAddress}
      onSubmitUpdate={props.onSubmitUpdateAddress}
      onSubmitDelete={props.onSubmitDeleteAddress}
      loading={props.loading}
      editingLoading={props.editingLoading}
      addingLoading={props.addingLoading}
      deletingLoading={props.deletingLoading}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    userId: userIdSelector(state),
    addresses: userAddressesSelector(state),
    loading: gettingUserAddressesLoadingSelector(state),
    editingLoading: editingUserAddressesLoadingSelector(state),
    addingLoading: addingUserAddressesLoadingSelector(state),
    deletingLoading: id => deletingUserAddressesLoadingByIdSelector(state, id),
  };
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps) => {
  return {
    getAddresses: () => {
      dispatch(getAddresses());
    },
    onSubmitNewAddress: address => dispatch(newAddress(address)),
    onSubmitUpdateAddress: address => dispatch(updateAddress(address)),
    onSubmitDeleteAddress: addressId => {
      dispatch(deleteAddress(addressId));
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(MyAccountAddressesPage);
